module.exports = __webpack_public_path__ + "static/img/cixiu_3.939accad.jpg";